"use client";

import React from "react";
import Image from "next/image";
import Banner from "@/components/Banner";
import Breadcrumbs from "@/components/Breadcrumbs";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import awardImg1 from "@/assets/award-1.png";
import awardImg2 from "@/assets/award-2.png";

// Import Swiper styles
// import "swiper/css";
// import "swiper/css/navigation";

const banner_bredcrumb_name = "Home / Auto";
const banner_name = "National Service Scheme";
const bannerUrl =
  "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/University+Students+Image.webp";
const tagline = "A Platform for Service, Leadership, and Social Impact";

const awards = [
  {
    img: "https://cdn.msu.edu.in/website-images/msu_nss_1.webp",
    alt: "School of Hospitality and Tourism",
    text: "Election Awareness Campaign 2024 by NSS",
  },
  {
    img: "https://cdn.msu.edu.in/website-images/msu_nss_5.webp",
    alt: "School of Indigenous Knowledge Research Application",
    text: "Skill Drill of Transportation of Casualties",
  },
  {
    img: "https://cdn.msu.edu.in/website-images/msu_nss_2.webp",
    alt: "School of Management and Commerce",
    text: "Skill Drill by NSS",
  },
  {
    img: "https://cdn.msu.edu.in/website-images/msu_nss_3.webp",
    alt: "School of Beauty and Wellness",
    text: "Skill Drill by NSS",
  },
  {
    img: "https://cdn.msu.edu.in/website-images/msu_nss_4.webp",
    alt: "School of Beauty and Wellness",
    text: "Skill Drill of Creating Makeshift Stretchers",
  },
  {
    img: "https://cdn.msu.edu.in/website-images/msu_nss_7.webp",
    alt: "School of Design",
    text: "Cleanliness Drive by NSS",
  },
  {
    img: "https://cdn.msu.edu.in/website-images/old-age.webp",
    alt: "Donation Drive",
    text: "Old-age Home Visit : Donation Drive",
  },
  {
    img: "https://cdn.msu.edu.in/website-images/msu_nss_6.webp",
    alt: "School of Design",
    text: "Skill Drill of Creating Makeshift Stretchers",
  },
];

function OurFaculty() {
  return (
    <div className="overflow-hidden">
      <Banner
        BannerImage={bannerUrl}
        banner_name={banner_name}
        banner_tag_line={tagline}
      />
      <Breadcrumbs items={[{ label: "NSS" }]} />

      <section className="page-container py-[20px] md:py-[50px]">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Side: Image Container */}
          <div className="w-full lg:w-1/2">
            <div className="relative">
              <Image
                src="https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/National+Service+Scheme.webp"
                alt="NSS Students Group"
                width={800}
                height={500}
                className="object-cover w-full h-auto"
                priority
                unoptimized
              />
            </div>
          </div>

          {/* Right Side: Text Content */}
          <div className="w-full lg:w-1/2 space-y-6">
            <h2 className="text-[30px] md:text-[42px] font-bold text-black mb-[15px]">
              National Service Scheme (NSS)
            </h2>

            <div className="space-y-4 text-[18px] leading-relaxed">
              <p>
                NSS, or the National Service Scheme is a Central Sector Scheme,
                under the Ministry of Youth Affairs & Sports, Government of
                India. NSS allows students to contribute to societal affairs
                through various activities in the fields of environmental
                conservation, health awareness campaigns, educational outreach
                and more. These initiatives help students to become responsible
                citizens of the country. They develop a sense of civic duty,
                empathy, enthusiasm to work in a team and leadership skills.
                Through the NSS initiatives as the integral part of the
                curriculum, we aim to nurture individuals who are able to
                address the complex societal challenges and are driven to make
                tangible contributions to their communities. Through these
                initiatives, students create an impact that extends far beyond
                the confines of the classroom.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="w-full overflow-hidden mb-[50px] md:mb-[80px] xl:mb-[100px]">
        <div className="relative w-full">
          {/* Swiper Container */}
          <div className="relative w-full overflow-hidden px-4 md:px-8 lg:px-12">
            <Swiper
              modules={[Navigation]}
              spaceBetween={16}
              slidesPerView={1.2}
              loop={true}
              navigation={{
                prevEl: ".swiper-button-prev-custom",
                nextEl: ".swiper-button-next-custom",
              }}
              breakpoints={{
                640: {
                  slidesPerView: 1.5,
                  spaceBetween: 16,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                },
                1024: {
                  slidesPerView: 2.5,
                  spaceBetween: 16,
                },
                1280: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
              }}
            >
              {awards.map((award, index) => (
                <SwiperSlide key={index}>
                  <div className="relative overflow-hidden group transition-transform duration-700 hover:scale-105">
                    <Image
                      src={award.img}
                      alt={award.alt}
                      width={500}
                      height={300}
                      className="object-cover w-full h-auto md:h-70 lg:h-90 transition-transform 
                      duration-700 group-hover:scale-110 overflow-hidden"
                    />

                    <div
                      className="absolute inset-0 z-10 opacity-100 overflow-hidden
                      md:opacity-100 lg:opacity-0 md:group-hover:opacity-100 transition-opacity duration-700"
                      style={{
                        background:
                          "linear-gradient(180deg, rgba(8, 30, 45, 0) 0%, #081E2D 100%)",
                      }}
                    />

                    <div
                      className="overflow-hidden absolute bottom-2 md:bottom-4 lg:bottom-6 left-5 right-2 z-20 text-white 
                      opacity-100 md:opacity-100 lg:opacity-0 md:group-hover:opacity-100 lg:group-hover:opacity-100 transition-opacity duration-700"
                    >
                      <p className="text-[13px] md:text-[14px] opacity-90 w-full break-words leading-tight line-clamp-2 overflow-hidden">
                        {award.text}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Desktop Navigation - Middle Left/Right */}
            <button
              className="swiper-button-prev-custom hidden md:flex absolute left-2 lg:left-4 top-1/2 -translate-y-1/2 z-10 
              w-10 h-10 lg:w-12 lg:h-12 items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-100 
              transition-all duration-300 cursor-pointer"
              aria-label="Previous slide"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lg:w-6 lg:h-6"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>

            <button
              className="swiper-button-next-custom hidden md:flex absolute right-2 lg:right-4 top-1/2 -translate-y-1/2 z-10 
              w-10 h-10 lg:w-12 lg:h-12 items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-100 
              transition-all duration-300 cursor-pointer"
              aria-label="Next slide"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lg:w-6 lg:h-6"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>

          {/* Mobile Navigation - Bottom Right */}
          <div className="flex md:hidden gap-2 justify-end mt-4 px-4">
            <button
              className="swiper-button-prev-custom w-10 h-10 flex items-center justify-center 
              bg-white rounded-full shadow-lg active:bg-gray-100 transition-all duration-300"
              aria-label="Previous slide"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>

            <button
              className="swiper-button-next-custom w-10 h-10 flex items-center justify-center 
              bg-white rounded-full shadow-lg active:bg-gray-100 transition-all duration-300"
              aria-label="Next slide"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurFaculty;
